// extracted by mini-css-extract-plugin
export var copyIcon = "_ys-2";
export var discountCard = "_ys-0";
export var discountCode = "_ys-3";
export var discountContent = "_ys-1";
export var loadingCard = "_ys-4";